import React from 'react';

import { Alert, AlertDescription, AlertTitle } from '@codes/ui-kit/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface ErrorCardProps {
    error?: Error | null;
    title?: string;
    description?: string;
    resetError?: () => void;
    resetButtonText?: string;
    className?: string;
}

export const ErrorCard: React.FC<ErrorCardProps> = ({
    error,
    title = 'Error',
    description,
    resetError,
    resetButtonText = 'Try again',
    className = '',
}) => {
    const errorMessage = description || error?.message || 'An unexpected error occurred.';

    return (
        <Alert variant="destructive" className={`mb-4 ${className}`}>
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>{title}</AlertTitle>
            <AlertDescription className="flex flex-col gap-2">
                <p>{errorMessage}</p>
                {resetError && (
                    <button
                        onClick={resetError}
                        className="text-sm underline text-destructive-foreground hover:opacity-80"
                    >
                        {resetButtonText}
                    </button>
                )}
            </AlertDescription>
        </Alert>
    );
};
